var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11C22 17.0748 17.0748 22 11 22C4.92521 22 0 17.0748 0 11C0 4.92521 4.92521 0 11 0C17.0761 0 22 4.92521 22 11Z",
    fill: "url(#paint0_linear_1311_1096)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8213 11.2856C11.8213 13.6526 10.0704 15.5714 7.91058 15.5714C5.75072 15.5714 4 13.6531 4 11.2856C4 8.91814 5.75086 7 7.91058 7C10.0703 7 11.8213 8.91872 11.8213 11.2856ZM16.1114 11.2856C16.1114 13.5138 15.2359 15.3199 14.156 15.3199C13.0762 15.3199 12.2007 13.5132 12.2007 11.2856C12.2007 9.05805 13.0762 7.25135 14.156 7.25135C15.2359 7.25135 16.1114 9.05805 16.1114 11.2856ZM17.8661 11.2856C17.8661 13.282 17.5581 14.9002 17.1784 14.9002C16.7986 14.9002 16.4906 13.2814 16.4906 11.2856C16.4906 9.28989 16.7986 7.67108 17.1785 7.67108C17.5584 7.67108 17.8661 9.28945 17.8661 11.2856Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1311_1096",
    x1: -7.36736e-9,
    y1: 11.0894,
    x2: 22,
    y2: 11.0894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.897463099d7061f0efc2057a35f8da6c.svg";
export { ForwardRef as ReactComponent };